import { DashboardTemplate } from '../../../../../../../interfaces/dashboards';
import { useLocation } from 'react-router';

export const useDashboardLocationState = (): DashboardTemplate | undefined => {
  const location = useLocation();
  return (location.state as any)?.template as DashboardTemplate | undefined;
};
